module.exports = __webpack_public_path__ + "img/logo111.c387893b.png";